import { useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const DEFAULT = {
  hero_title: 'Dubinsko čišćenje koje vraća sjaj vašem domu',
  hero_subtitle:
    'Premium deep cleaning servis u Nišu. Stanovi, poslovni prostori, tepisi i tapacirani nameštaj – profesionalno, pouzdano, sa pažnjom za svaki detalj.',
  hero_badge: 'Premium servis · Niš',
  cta_primary: 'Zakaži čišćenje',
  cta_secondary: 'Besplatna procena',
  phone: '+381 60 000 0000',
  email: 'kontakt@dubinko.rs',
  instagram: 'https://www.instagram.com/dubinko_nis_018/',
  address: 'Niš, Srbija',
  ga_id: '',
  gsc_verification: '',
  gbp_url: '',
  business_street: 'Vojvode Stepe 1',
  business_postal: '18000',
  business_city: 'Niš',
  business_country: 'RS',
  business_lat: 43.3209,
  business_lng: 21.8958,
  opening_hours: 'Mo-Sa 08:00-20:00',
  hero_image_url: 'https://images.unsplash.com/photo-1758273705627-937374bfa978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBkZWVwJTIwY2xlYW5pbmclMjBob21lJTIwbW9kZXJufGVufDB8fHx8MTc4MjI3MTE0MHww&ixlib=rb-4.1.0&q=85',
  before_image_url: 'https://images.unsplash.com/photo-1698505836028-20ea78bad567?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtZXNzeSUyMGNsdXR0ZXJlZCUyMHJvb218ZW58MHx8fHwxNzgyMjcxMTUyfDA&ixlib=rb-4.1.0&q=85',
  after_image_url: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1vZGVybiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzgyMjcxMTQwfDA&ixlib=rb-4.1.0&q=85',
  about_image_url: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80',
  services: [],
  steps_title: 'Kako funkcioniše',
  steps_subtitle: 'Od prvog klika do besprekorno čistog prostora.',
  steps: [],
  cta_bottom_title: 'Spremni za sjajan prostor?',
  cta_bottom_subtitle: 'Zakažite termin u manje od 2 minuta — ili nas pozovite za besplatnu procenu.',
  values_title: 'Naše vrednosti',
  values: [],
  google_place_id: '',
  google_maps_embed_url: '',
  google_maps_api_key: '',
  whatsapp_number: '',
  viber_number: '',
  google_ads_conversion_id: '',
  google_ads_conversion_label: '',
  facebook_pixel_id: '',
  promo_active: false,
  promo_code: 'PRVI15',
  promo_percent: 15,
  promo_banner_text: 'Prvo čišćenje -15% — kod: PRVI15',
};

export function useSiteContent() {
  const [content, setContent] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/site/content');
      setContent({ ...DEFAULT, ...data });
    } catch (e) {
      setContent(DEFAULT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { content, loading, reload: load, setContent };
}
